<template>
    <sui-segment :loading="isLoading" class="gateways-list">
        <div class="header-container">
            <div>
                <h1 is="sui-header">{{ $t('gateway.mainList.title') }}</h1>
            </div>
            
            <router-link
                class="ui violet button right floated"
                :to="{ name: 'GatewayForm' }"><sui-icon name="plus"/>{{ $t('gateway.mainList.new') }}</router-link>
        </div>

        <sui-table class="compact" celled striped selectable>
            <sui-table-header>
                <sui-table-row>
                    <sui-table-header-cell :width="1">{{ $t('common.id') }}</sui-table-header-cell>
                    <sui-table-header-cell :width="2">{{ $t('common.name') }}</sui-table-header-cell>
                    <sui-table-header-cell :width="2">{{ $t('gateway.mainList.getType') }}</sui-table-header-cell>
                    <sui-table-header-cell :width="3">{{ $t('gateway.mainList.nextGet') }}</sui-table-header-cell>
                    <sui-table-header-cell :width="3">{{ $t('common.comment') }}</sui-table-header-cell>
                    <sui-table-header-cell :width="4">{{ $t('common.actions') }}</sui-table-header-cell>
                </sui-table-row>
            </sui-table-header>
            <sui-table-body>
                <sui-table-row v-for="gateway in this.state.gateways" :key="gateway.id">
                    <sui-table-cell>{{ gateway.id }}</sui-table-cell>
                    <sui-table-cell>
                        <router-link :to="{ name: 'GatewayOverview', params: { gateway_id: gateway.id }}">
                            {{ gateway.name }}
                        </router-link>
                    </sui-table-cell>
                    <sui-table-cell>{{ gateway.configuration.fetch_method }}</sui-table-cell>
                    <sui-table-cell>
                        <NextGatewayFileDownloadCronTaskInfos v-if="gateway.configuration" :cronExpression="gateway.configuration.cron_expression"/>
                    </sui-table-cell>
                    <sui-table-cell>
                        {{ gateway.comment }}
                    </sui-table-cell>
                    <sui-table-cell text-align="center">
                        <router-link
                            class="ui tiny button"
                            :to="{ name: 'GatewaySettings', params: { gateway_id: gateway.id }}">{{ $t('common.configuration') }}</router-link>

                        <router-link
                            class="ui tiny button"
                            :to="{ name: 'GatewayInstructions', params: { gateway_id: gateway.id }}">{{ $t('common.instructions') }}</router-link>

                        <router-link
                            class="ui tiny button"
                            :to="{ name: 'GatewayBindings', params: { gateway_id: gateway.id }}">{{ $t('common.binding') }}</router-link>
                    </sui-table-cell>
                </sui-table-row>

            </sui-table-body>
        </sui-table>
    </sui-segment>
</template>
<script>
    import store from '@/store';
    import NextGatewayFileDownloadCronTaskInfos from '@/components/gateway/NextGatewayFileDownloadCronTaskInfos';

    export default {
        name: 'GatewaysList',
        components: {
            NextGatewayFileDownloadCronTaskInfos,
        },
        mounted() {
            store.commit('setAppTitle', `${this.$t('common.transactionSoftwares')}`);
        },
        beforeDestroy() {
            store.commit('removeAppTitle');
        },
        data() {
            return {
                clock: null,
                state: store.state,
                isLoading: false,
                parameters: {
                    nextGatewayProcessCronTask: null,
                }
            }
        },
        async created() {
            this.isLoading = true
            await store.dispatch('getGateways');
            this.isLoading = false;
        },
    }
</script>
